<button [class.active]="isActive" (click)="saveFavorites()">
  <span>Favorita</span>
  <mat-icon>check_circle</mat-icon>
</button>
